import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
export default function Breadcrumb() {
  const { breadcrumbs } = useSelector((state) => state.breadcrumbs);

  return (
    <div className="container pt-6 pb-4 min-h-12">
      <nav aria-label="Breadcrumb" className="ui-breadcrumb text-xs">
        {breadcrumbs.length > 1 && (
          <ol className="list-none">
            {breadcrumbs.map((b, key) => {
              return (
                <li key={`breadcrumb-${key}`}>
                  <Link to={b.url} aria-current={b.url === "#" ? "page" : ""}>
                    {b.name}
                  </Link>
                </li>
              );
            })}
          </ol>
        )}
      </nav>
    </div>
  );
}
